
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/automation-rules",
      function () {
        return require("private-next-pages/automation-rules/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/automation-rules"])
      });
    }
  